const RecommendList = () => import('Views/recommend/recommend-list');

export default[
  { path: '/recommend-list', component: RecommendList },
];



// WEBPACK FOOTER //
// ./src/router/recommend.js